// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2aFIc","boxTitle":"Qualiphy_boxTitle__3k7gs","box":"Qualiphy_box__3cRxy","toggleWrap":"Qualiphy_toggleWrap__1j_R1"};